import type { JSX, PropsWithChildren } from 'react';

import { Radio } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { HighlightText } from '../HighlightText';

import { useSelectionCard } from './hooks/useSelectionCard';
import { RadioLabel } from './RadioLabel';
import { containerStyles, contentBoxStyles, radioStyles } from './styles';

export type Props = PropsWithChildren<{
	highlight?: string;
	label: string;
	message: string;
	onSelect: () => void;
	checked: boolean;
	qaSelectorSelection: string;
	qaSelectorLabel: string;
	qaSelectorMessage: string;
}>;

// TODO: Improve the complexity of this component once the sunrise experiments are productized

export function Selection({
	qaSelectorSelection,
	qaSelectorLabel,
	qaSelectorMessage,
	label,
	message,
	highlight,
	onSelect,
	checked,
	children,
}: Props): JSX.Element {
	const { data: koiPpmuDesignExperimentVariantStyles } = useSelectionCard(checked);

	return (
		<Box
			sx={containerStyles({
				checked,
				borderBackgroundColor: koiPpmuDesignExperimentVariantStyles.borderBackgroundColor,
				borderColor: koiPpmuDesignExperimentVariantStyles.borderColor,
			})}
			onClick={onSelect}
		>
			{highlight && <HighlightText text={highlight} selected={checked} />}
			<Box
				sx={contentBoxStyles({
					checked,
					highlight,
					backgroundColor: koiPpmuDesignExperimentVariantStyles.backgroundColor,
				})}
			>
				<Radio
					data-qa={qaSelectorSelection}
					data-testid="selection-radio"
					checked={checked}
					readOnly
					sx={radioStyles}
					label={
						<RadioLabel
							qaSelectorLabel={qaSelectorLabel}
							qaSelectorMessage={qaSelectorMessage}
							label={label}
							message={message}
						>
							{children}
						</RadioLabel>
					}
				/>
			</Box>
		</Box>
	);
}
